import ReactGA from "react-ga";
import {GOOGLE_ANALYTICS} from "../app/index"

export default class Common {
  static googleAnalyticsEvent(category, action, label = null) {
    ReactGA.initialize(GOOGLE_ANALYTICS.KEY);

    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  }
}
